import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: false,
};
//dikkat başlangıta değer fal geliyor ve sorasın tur geltirim kaldığın class ve chapter değeri burdan alyor.
const classActiveSlice = createSlice({
  name: "classActive",
  initialState,
  reducers: {
    classActive: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { classActive } = classActiveSlice.actions;
export default classActiveSlice.reducer;
